module.exports = __webpack_public_path__ + "img/79089fcdf30149e7e4d419d5056c5541.png";